<template>
  <b-col lg="12" class="b-col-514 bg-dark text-white">
    <b-container>
      <b-row>
        <b-col lg="6" md="12" ms="12" class="text-center">
          <slot name="pr-2"></slot>
        </b-col>

        <b-col lg="6" md="12" ms="12">
          <slot name="pl-1"></slot>
        </b-col>
      </b-row>

      <b-row class="mt-5">
        <b-col lg="6" md="12" sm="12" class="text-center order-lg-1">
          <slot name="pl-2"></slot>
        </b-col>

        <b-col lg="6" md="12" sm="12">
          <slot name="pr-1"></slot>
        </b-col>
      </b-row>
    </b-container>
  </b-col>
</template>

<script>
export default {
  name: "S513",
};
</script>

<style scoped>
.b-col-514 {
  padding: 0px;
}

.col-p-514 {
  font-size: 20px;
  font-weight: bold;
  transition: 0.3s;
  padding: 17px;
}
.col-p-514:hover {
  color: var(--light-pink);
  transition: 0.3s;
}
.col-img-514 {
  transition: 0.3s;
}
.col-img-514:hover {
  transform: scale(1.03);
  transition: 0.3s;
}
</style>
